import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Environment } from '../../environments/model/environment.model';

@Injectable({
  providedIn: 'root',
})
export class IkpEnvironmentService {
  private environment: Environment;

  constructor() {
    this.environment = environment;
  }

  getApiUrl(): string {
    return this.environment.apiUrl;
  }

  getMaintenanceRefreshIntervall(): number {
    return 5000;
  }

  getLoggingAPIOBaseURL(): string {
    return '';
  }

  getBaseUrl(): string {
    return this.environment.baseUrl;
  }

  getKeycloakUrl(): string {
    return this.environment.keycloakUrl;
  }

  isPiwikProTrackingDebugEnabled(): boolean {
    return this.environment.isPiwikProTrackingDebugEnabled;
  }

  getPiwikTagPropertyId(): string {
    return this.environment.piwikTagPropertyId;
  }

  getCookieConsentDataUrl(): string {
    return this.environment.cookieConsentDataUrl;
  }

  getStaticContentUrl() {
    return this.environment.staticContentUrl;
  }

  staticContent(): string {
    return this.environment.mweStaticContentUrl;
  }

  getMazePropertyId() {
    return this.environment.mazePropertyId;
  }

  isProduction(): boolean {
    return this.environment.production;
  }

  getFeedbackUrl(): string {
    return this.environment.feedbackUrl;
  }
}
